import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { CompliancePanel } from "@/components/OutputCard";
import { ShieldCheck, RefreshCw } from "lucide-react";

export default function ComplianceView() {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const check = async () => {
    if (!text.trim()) { toast.error("Paste some listing copy to scan."); return; }
    setLoading(true);
    setResult(null);
    try {
      const { data } = await api.post("/compliance/check", { text });
      setResult(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl">
      <div className="bg-white border border-slate-200 rounded-lg p-6">
        <h2 className="font-semibold text-lg flex items-center gap-2"><ShieldCheck className="h-5 w-5" /> Fair Housing checker</h2>
        <p className="text-sm text-slate-500 mt-1">Paste any listing copy. We'll flag protected-class references and steering language with compliant rewrites.</p>
        <Textarea data-testid="compliance-input" value={text} onChange={(e) => setText(e.target.value)} rows={7} className="mt-4"
          placeholder="Paste a description, caption, or email here…" />
        <Button onClick={check} disabled={loading} data-testid="compliance-check-btn" className="mt-4 h-11 bg-slate-900 hover:bg-slate-800 text-white font-semibold">
          {loading ? <><RefreshCw className="h-4 w-4 mr-2 animate-spin" /> Scanning…</> : <><ShieldCheck className="h-4 w-4 mr-2" /> Scan for compliance</>}
        </Button>
      </div>
      {result && <div className="mt-5"><CompliancePanel compliance={result} /></div>}
    </div>
  );
}
